import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Exit = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 25 25"
      className="feather feather-x"
      color={iconColor}
    >
      <title>{iconTitle}</title>
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
};

Exit.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Exit.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Exit);
